import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { ReactComponent as Extrato } from "../../assets/novosicones/acessos-rapidos/Extrato.svg";
import { ReactComponent as Documentos } from "../../assets/novosicones/acessos-rapidos/Documentos.svg";
import { ReactComponent as MeusBoletos } from "../../assets/novosicones/acessos-rapidos/MeusBoletos.svg";
import { ReactComponent as NovaSolicitacao } from "../../assets/novosicones/acessos-rapidos/NovaSolicitacao.svg";
import { ReactComponent as AnteciparParcelas } from "../../assets/novosicones/acessos-rapidos/AnteciparParcelas.svg";
import Fade from "@material-ui/core/Fade";
import { ContextoListaApartamentos } from "../ApartamentList/contextoImoveis";

import "./styles.scss";

const FastAccesses = () => {
  const { tema } = useContext(ContextoListaApartamentos);

  var stringClasseTema = tema.tipo == "Riva" ? "temaRiva" : "temaDirecional";

  return (
    <Fade in>
      <div
        className="fastAccess centralized "
        style={{ backgroundColor: tema.primaryColor, transition: "0.6s" }}
      >
        <div className="fastAccess__icons centralized-space-evenly grid-container-menu">
          <Link to="/financeiro">
            <button className="centralized-space-evenly grid-item-menu">
              <Extrato className={stringClasseTema} />

              <span style={{ color: tema.primaryColor, fontWeight: "900" }}>
                Extrato
              </span>
            </button>
          </Link>
          <Link to="/financeiro">
            <button className="centralized-space-evenly grid-item">
              <MeusBoletos className={stringClasseTema} />
              <span style={{ color: tema.primaryColor, fontWeight: "900" }}>
                Meus boletos
              </span>
            </button>
          </Link>
          <Link to="/financeiro">
            <button className="centralized-space-evenly grid-item">
              <AnteciparParcelas className={stringClasseTema} />

              <span style={{ color: tema.primaryColor, fontWeight: "900" }}>
                Antecipar parcelas
              </span>
            </button>
          </Link>
          <Link to="/solicitacoes/nova-solicitacao" className="grid-item2">
            <button className="centralized-space-evenly">
              <NovaSolicitacao className={stringClasseTema} />

              <span style={{ color: tema.primaryColor, fontWeight: "900" }}>
                Novas Solicitações
              </span>
            </button>
          </Link>
          <Link to="/meu-imovel" className="grid-item2">
            <button className="centralized-space-evenly">
              <Documentos className={stringClasseTema} />

              <span style={{ color: tema.primaryColor, fontWeight: "900" }}>
                Documentos
              </span>
            </button>
          </Link>
        </div>
      </div>
    </Fade>
  );
};

export default FastAccesses;
